/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

/**
 * @class
 *
 * @param {Object} config object
 * @param {number} [config.width] width of canvas
 * @param {number} [config.height] height of canvas
 * @constructor
 */
function Canvas ( config ) {

    config = config || {};

    this.$dom = document.createElement('canvas');

    if ( config.width ) {
        this.$dom.width = config.width;
    }

    if ( config.height ) {
        this.$dom.height = config.height;
    }

    this.context = this.$dom.getContext('2d');

    this.currentImage = null;
}

Canvas.prototype = Object.create({});
Canvas.prototype.constructor = Canvas;


/**
 * Append canvas to given node
 *
 * @param {HTMLElement} domNodeToAppend canvas node
 */
Canvas.prototype.appendTo = function ( domNodeToAppend ) {
    domNodeToAppend.appendChild(this.$dom);
};

/**
 * Draw image to canvas from given url
 *
 * @param {string} imageUrl to draw
 * @param {Canvas~drawCallback} callback after drawing
 */
Canvas.prototype.drawImageFromUrl = function ( imageUrl, callback ) {
    var self = this,
        image = document.createElement('img');

    image.src = imageUrl;

    image.onload = function () {
        //
        self.context.drawImage(image, 0, 0);
        self.currentImage = image;
        if ( callback ) {
            callback(false);
        }
    };

    image.onerror = function () {
        if ( callback ) {
            callback(true);
        }
    };
};

/**
 * This callback is displayed as part of the Requester class.
 *
 * @callback Canvas~drawCallback
 * @param {boolean} error state of operation
 */


/**
 * Clear rectangle area from canvas
 *
 * @param {Object} rect parameters to clear
 * @param {number} rect.x x coordinate
 * @param {number} rect.y y coordinate
 * @param {number} rect.width width of area
 * @param {number} rect.height height of area
 */
Canvas.prototype.clearRect = function ( rect ) {
    rect = rect || {};

    this.context.clearRect(rect.x, rect.y, rect.width, rect.height);
};

/**
 * Restore last drawn image
 *
 * @return {boolean} state of operation
 */
Canvas.prototype.restoreImage = function () {
    if ( !this.currentImage ) {
        return false;
    }

    this.context.drawImage(this.currentImage, 0, 0);

    return true;

};


/**
 * Get base64 string of current image
 *
 * @return {string} base64 string of current image
 */
Canvas.prototype.getBase64String = function () {

    return this.$dom.toDataURL();
};


/**
 * Get image from document.body style and draw on canvas
 *
 * @param {Canvas~drawCallback} callback after drawing
 */
Canvas.prototype.loadImageFromBodyBackground = function ( callback ) {
    var imgUrl;

    imgUrl = window.getComputedStyle(document.body).backgroundImage
        .replace('url("', '').replace('")', '')
        .replace('url', '').replace('(', '').replace(')', '');

    if ( !imgUrl ) {
        callback(true);
    } else {
        this.drawImageFromUrl(imgUrl, callback);
    }


};

module.exports = Canvas;
